import React, { Component } from 'react';
import ImageRenderer from './ImageRenderer';
import VideoRenderer from './VideoRenderer';
import WebRenderer from './WebRenderer';
import WidgetRenderer from './WidgetRenderer';
import VideoURLRenderer from './VideoURLRenderer';

class PlaylistRenderer extends Component {
    // static proptypes = {
    //     children: PropTypes.func.isRequired
    // }

    state = {
        playlistData: null
    }

    componentDidMount() {
        this.updateDataFromProps(this.props)
    }

    componentWillReceiveProps = (props) => {
        this.updateDataFromProps(props);
    }

    updateDataFromProps = (props) => {
        if (!props)
            return

        const { data = null, time = 0 } = props;

        if (data) {
            this.setState({ playlistData: data, time: time }, () => { this.prepareData() })
        }
        else {
            this.setState({ time: time })
        }
    }

    prepareData = () => {
        const { playlistData = null } = this.state;

        if (!playlistData) {
            return null;
        }

        const { name = "", duration = -1, scale = "fill", contents = [] } = playlistData;

        var totalTime = 0;
        contents.forEach((data) => {
            const { duration = 0 } = data
            data.start_time = totalTime;
            totalTime += duration;
        })
        playlistData.total_time = totalTime;
    }

    getCurrentMedia = () => {

        if (!this.state.playlistData) {
            return null;
        }
        // console.log(time)
        var inRoundTime = this.state.time - Math.floor(this.state.time / this.state.playlistData.total_time) * this.state.playlistData.total_time;


        var toplayContents = this.state.playlistData.contents.filter((content) => {
            return (content.start_time <= inRoundTime) && ((content.start_time + content.duration) > inRoundTime) && (content.duration > 0);
        })

        // console.log("toplayContents.length  " + toplayContents.length )
        if (toplayContents.length >= 0) {
            return toplayContents[0];
        }

        return null;
    }

    render() {
        if (!this.state.playlistData)
            return null;


        const currentContent = this.getCurrentMedia();
        // console.log("found img " + currentContent);

        if (!currentContent) {
            return null;
        }

        const { FileType = "", MediaType = "File" } = currentContent;
        const type = FileType.toLocaleLowerCase();
        var renderMedia = null;

        const { playOnStart = true, showControls = false } = this.props;

        switch (MediaType) {
            case "Widget":
                renderMedia = <WidgetRenderer data={currentContent}></WidgetRenderer>
                break;
            default:
                switch (type) {
                    case "image":
                        renderMedia = <ImageRenderer data={currentContent}></ImageRenderer>
                        break;
                    case "video":
                        renderMedia = <VideoRenderer playOnStart={playOnStart} showControls={showControls} data={currentContent}></VideoRenderer>
                        break;
                    case "web":
                        renderMedia = <WebRenderer data={currentContent}></WebRenderer>
                        break;
                    case "videourl":
                        renderMedia = <VideoURLRenderer data={currentContent}></VideoURLRenderer>
                        break;
                }
                break;
        }

        return (
            <div style={{ width: '100%', height: '100%' }}>
                {renderMedia}
            </div>
        )
    }
}

export default PlaylistRenderer